<template>
    <div class="statistics">
        <div class="bar">
            <el-form :inline="true" class="rform" label-position='left'>
                <el-autocomplete
                    popper-class="my-autocomplete"
                    v-model="barform.mechanName"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入机构名称"
                    @select="handleSelect">
                     <template slot="prepend">机构名称</template>
                    <template slot-scope="{ item }">
                        <span class="addr">{{ item.name }}</span>
                    </template>
                </el-autocomplete>
                <el-form-item label="保单号"  class="item">
                    <el-input type="text" placeholder="请输入保单号" v-model="barform.policyNo" class="code"></el-input>
                </el-form-item>
                <el-form-item label="时间"  class="item">
                <el-date-picker
                    v-model="barform.date"
                    type="daterange"
                    @change="changeTime"
                    value-format = 'yyyy-MM-dd'
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                </el-form-item>
                <el-button class="items" type="warning" @click="query">查询</el-button>
                <el-button class="items" type="warning" plain @click="daochu">导出</el-button>
            </el-form>
        </div>
        <div class="content">
            <span class="red">已过犹豫期保单（含续期保单）业绩，点击右上角[导出]按钮可导出业绩数据表</span>
            <!-- <el-table  class="omtable" ref="singleTable" :summary-method="getSummaries" sum-text border show-summary :stripe='true' :data="tableData" style="width: 100%"> -->
            <el-table  class="omtable" ref="singleTable" border :stripe='true' :data="tableData" style="width: 100%">
                <el-table-column type="index" width="60px"></el-table-column>
                <el-table-column property="mechanName" label="机构名称"></el-table-column>
                <el-table-column property="policyNo" label="保单号"></el-table-column>
                <el-table-column property="productName" label="产品名称" ></el-table-column>
                <el-table-column property="waverLimit" label="犹豫期" ></el-table-column>
                <el-table-column property="payTime" label="出单时间" >
                    <template  slot-scope="scope">
                        <span>{{scope.row.payTime|timeSubstr(0,16)}}</span>
                    </template>
                </el-table-column>
                <el-table-column property="fee" label="保费（元）"></el-table-column>
                <el-table-column property="payNum" label="年限">
                    <template slot-scope="scope">
                        <span v-if="scope.row.payNum==1">首年</span>
                        <span v-else>第{{scope.row.payNum}}年</span>
                    </template>
                </el-table-column>
                <el-table-column property="income" label="服务费（元）">
                    <template slot-scope="scope">
                        <el-popover placement="top" trigger='hover'>
                            <div>
                                <span>服务费：</span>
                                <span>{{scope.row.income||"--"}}</span>
                            </div>
                            <div>
                                <span>主险服务费：</span>
                                <span>{{scope.row.mainTotalIncomes||"--"}}</span>
                            </div>
                            <div>
                                <span>附加险服务费：</span>
                                <span>{{scope.row.additionIncomes||"--"}}</span>
                            </div>
                            <span slot="reference" class="wenhao">?</span>
                        </el-popover>
                        <span>{{scope.row.income||"--"}}</span>
                    </template>
                </el-table-column>
                <el-table-column property="totalIncome" label="机构服务费（元）"></el-table-column>
                <el-table-column label="我的利润（元）">
                    <template slot-scope="scope">
                        <span>{{scope.row.profit}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
            class="page"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size='pagesize'
            :current-page.sync='tableCurrent'
            :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    //当前实例组件
    import common from '../../api/common.js'
    export default {
        data: () => ({
            barform: {
                policyNo: '',
                mechanName: '',
                sureDate: '',
            },
            pagesize: 10,
            total: 0,
            twoMechanId:"",
            tableData: [],
            sureDate: '',
            restaurants:[],
            tableCurrent:1
        }),
        components: {

        },
        created() {
            this.getTableData();
            this.channelAjax();//二级机构查询
        },
        methods: {
            handleSelect(item) {
                console.log(item);
                this.barform.mechanName=item.name;
                this.twoMechanId= item.id;
                this.tableCurrent = 1;
                this.getTableData(1, this.barform.policyNo, item.id);

            },
            channelAjax(){//二级机构查询
                var that = this
                this.$http({
                    url: '/master/mechan/querySubMechanList',
                    type: 'put',
                    params: {},
                }).then(function(data) {
                    that.restaurants=data.data;
                })
            },
            //导出
            daochu:function(){
                const params = this.getParams();
                var url = this.$config.api_root+"/master/level2/achievement/export?"+this.$tools.urlEncode(params);
                console.log(url)
                window.open(url);
            },
            querySearch(queryString, cb) {
                var that=this
                var restaurants = this.restaurants;
                this.twoMechanId="";
                let results;
                if(queryString){
                    results=that.createFilter(queryString)
                }else{
                    results=restaurants;
                }
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                if(this.restaurants.length<=0){
                    return;
                }
                var newRestaurants=[];
                for (var item in this.restaurants) {
                    var shortNames=this.restaurants[item].name
                    if(shortNames.indexOf(queryString)>=0){
                        newRestaurants.push(this.restaurants[item]);
                    }
                }
                return newRestaurants;
            },
            handleIconClick(ev) {
                console.log(ev);
            },
            //时间切换
            changeTime:function(data){
                console.log(this.barform.date);
                this.getTableData(1);
            },
            //搜索点击
            query: function() {
                this.tableCurrent = 1;
                this.getTableData(1);
            },
            handleCurrentChange: function(val) {
                this.getTableData(val);
            },
            getSummaries:function(param){//合计
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                };
                if (index === 0||index === 1||index === 2||index === 3||index === 4||index === 6) {
                    sums[index] = '——';
                    return;
                };
                let values;
                 values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                        }, 0);
                        sums[index] = sums[index].toFixed(2);
                    } else {
                        sums[index] = 'N/A';
                    }
                });
                return sums;
            },
            getParams(){
                const params = {
                    startDate: this.barform.startDate,
                    endDate: this.barform.endDate,
                    policyNo: this.barform.policyNo,
                    mechanName: this.barform.mechanName
                }
                return params;
            },
            //获取主数据
            getTableData: function(num) {
                // var sureDate = '';
                // var time = new Date()
                // var year = time.getFullYear();
                // var month = time.getMonth() + 1;
                // month = (month < 10 ? "0" + month : month);
                // if (!this.barform.sureDate) {
                //     this.barform.sureDate = year + '-' + month
                // }
                if(this.barform.date && this.barform.date.length==2){
                    this.barform.startDate = this.barform.date[0]
                    this.barform.endDate = this.barform.date[1]
                }else{
                    this.barform.startDate = "";
                    this.barform.endDate = "";
                }
                const params = this.getParams();
                params.pageSize = 10;
                params.pageNum = num;
                this.$http({
                    url:'/master/level2/achievement/list',
                    type:'put',
                    params: params,
                }).then((data)=> {
                    this.tableData = data.data;
                    for(var i = 0;i<data.data.length;i++){
                        if(data.data[i].oneSubsidyCommission){
                            data.data[i].commissionTotal = (data.data[i].oneCommission*1+data.data[i].oneSubsidyCommission*1).toFixed(2)
                        }else{
                            data.data[i].commissionTotal = (data.data[i].oneCommission*1).toFixed(2)
                        }
                    }
                    this.total = data.total;
                })
            }
        },
        mounted() {

        }
    };
</script>
<style lang="scss">
    .statistics {
        padding: 30px;
        background: #fff;
        .red{
            color: red;
            margin-bottom: 10px;
            display: block;
            font-size: 14px;
        }
        .wenhao {
            width: 20px;
            height: 20px;
            border-radius: 20px;
            background: #fff;
            border: 1px solid #ccc;
            color: #ccc;
            display: inline-block;
            text-align: center;
            line-height: 20px;
            font-size: 16px;
            cursor: pointer;
        }
    }
</style>
